module.exports = __webpack_public_path__ + "img/img_futa_lace.81dccbf8.png";